
import React, { useState, useEffect } from 'react';
import {
	Navigate,
	useLocation,
	useNavigate,
} from 'react-router-dom';
import { getCurrentUser, hasFeatureAccess, shouldBlockFeatureAccess } from './Utils'
import { isAuthGuardActive } from '../constants/defaultValues';
import FeatureNotAvailableModal from '../components/common/Modal/FeatureNotAvailableModal';

/** Features invite links: /app/settings/features/cloud_id=CXDO or ?cloud_id=CXDO */
const isFeaturesCloudInvite = (location) => {
	if (!location?.pathname?.includes('/settings/features')) {
		return false;
	}
	if (/cloud_id=/i.test(location.pathname)) {
		return true;
	}
	return new URLSearchParams(location.search || '').has('cloud_id');
};

const ProtectedRoute = ({ children, roles = undefined }) => {
	const location = useLocation();
	
	if (isAuthGuardActive) {
		const currentUser = getCurrentUser();
		if (currentUser) {
			if (roles) {
				if (roles.includes(currentUser.role)) {
					return children;
				} else {
					return <Navigate
						to="/unauthorized"
						state={{ from: location   }}
						replace
					/>;
				}
			} else {
				return children;
			}
		} else if (isFeaturesCloudInvite(location)) {
			// Allow Features invite URL through; page shows email/password modal.
			return children;
		} else {
			return <Navigate
				to="/user/login"
				state={{ from: location   }}
				replace
			/>;
		}
	} else {
		return children;
	}
}
const UserRole = {
	Admin: 0,
	Editor: 1,
}

const FeatureProtectedRoute = ({ children, featureLabel }) => {
	const [showModal, setShowModal] = useState(false);
	const [hasAccess, setHasAccess] = useState(true);
	const navigate = useNavigate();

	useEffect(() => {
		if (featureLabel) {
			const access = hasFeatureAccess(featureLabel);
			setHasAccess(access);
			if (!access) {
				setShowModal(true);
			}
		}
	}, [featureLabel]);

	const closeModal = () => {
		setShowModal(false);
		navigate('/app/settings/features');
	};

	if (!featureLabel) {
		return children;
	}

	if (!hasAccess) {
		return (
			<>
				<div></div>
				<FeatureNotAvailableModal
					isOpen={showModal}
					toggle={closeModal}
					featureLabel={featureLabel}
				/>
			</>
		);
	}

	return children;
};

export { ProtectedRoute, UserRole, FeatureProtectedRoute };
